const BASE_CTA_URL = 'https://web.tevh.in/oArk';

export function getCtaUrl(baseUrl = BASE_CTA_URL) {
  const params = new URLSearchParams(window.location.search);
  const utmParams = new URLSearchParams();

  for (const [key, value] of params.entries()) {
    if (key.startsWith('utm_')) {
      utmParams.set(key, value);
    }
  }

  const utmString = utmParams.toString();
  return utmString ? `${baseUrl}?${utmString}` : baseUrl;
}

export { BASE_CTA_URL };
